import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsDesktopLoginComponent } from '../../../core/model';
import { UserFacade } from '../../../core/user';
import { LoginFormView } from '../shared/model/login-form-view.model';

@Component({
  selector: 'py-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  view: LoginFormView = LoginFormView.Login;
  isLoading: boolean = false;
  loginFormView = LoginFormView;

  constructor(
    public component: CmsComponentData<CmsDesktopLoginComponent>,
    private activatedRoute: ActivatedRoute,
    private userService: UserFacade
  ) {}

  ngOnInit(): void {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    if (!!queryParams && !!queryParams.view) {
      this.changeView(Number(queryParams.view));
    }
  }

  changeView(view: LoginFormView): void {
    this.view = view;
  }

  setLoading(state: boolean): void {
    this.isLoading = state;
  }

  back(): void {
    this.userService.resetRequestForgotPasswordEmailProcessingState();
    this.view = this.loginFormView.Login;
  }
}
